export default class VehicleHelper {

    // Si les donnée sdu valet sont ok pour être validées
    static IsVehicleValidated(vehicleData) {
        return vehicleData.car_category_id != null;
    }
}